var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./confidential_issue_warning.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5b8765d4\"}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./confidential_issue_warning.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./vue_shared/components/issue/confidential_issue_warning.vue
// module id = ./vue_shared/components/issue/confidential_issue_warning.vue
// module chunks = common_vue